function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M172.7 156L144 118.5V64c0-26.5-21.5-48-48-48S48 37.5 48 64v54.5L19.3 156h53c1.9 11.3 11.8 20 23.7 20s21.7-8.7 23.7-20h53zM56 121.5V64c0-22.1 17.9-40 40-40s40 17.9 40 40v57.5l19.3 26.5H36.7L56 121.5zM96 168c-7.4 0-13.7-5.1-15.5-12h30.9c-1.7 6.9-8 12-15.4 12z",
    style: {
      fill: "#71767c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0a3f4ed41f5d65d1d5aac8ecfec06833.svg";
export { ForwardRef as ReactComponent };